// extracted by mini-css-extract-plugin
export default {"requisitesContainer":"Requisites_requisitesContainer__VNB0-","tableWrapper":"Requisites_tableWrapper__wkFGj","requisitesTable":"Requisites_requisitesTable__vRPcg"};